import Titulo from '@/components/Layout/Title';
import Card from '@/components/Layout/Card';
import { useState, useMemo } from 'react';
import { listingRearranger } from '@/components/Ads/Rearrangers';
import InfiniteScrollComponent from '@/components/Layout/ObserverInfiniteScroll';
import LoadingLogo from '@/components/Layout/LoadingLogo';
import { PlaylistCardList } from '../PlaylistCard/styles';

export interface Company {
  id: string;
  titulo: string;
  imagem: {
    url: string;
    blurhash: string;
  };
  url: string;
  [key: string]: any;
}

interface CompaniesListProps {
  companies: Company[];
}

export default function CompaniesList({ companies }: CompaniesListProps) {
  const rearrangedCompanies = useMemo(() => {
    return listingRearranger<Company>({
      content: companies,
      primary: true,
      hasNoAds: true,
      sizeMobile: 24,
      sizeDesktop: 24,
    }).filter((arranged): arranged is { chunck: Company[] } => {
      if ('chunck' in arranged) return true;
      return false;
    });
  }, [companies]);

  const [nextChunk, setNextChunk] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const displayedCompanies = useMemo(() => {
    return rearrangedCompanies
      .slice(0, nextChunk)
      .flatMap(chunk => chunk.chunck);
  }, [rearrangedCompanies, nextChunk]);

  const getMoreCompanies = () => {
    if (nextChunk >= rearrangedCompanies.length) return;

    setIsLoading(true);
    setNextChunk(prev => Math.min(prev + 1, rearrangedCompanies.length));
    setIsLoading(false);
  };

  return (
    <>
      <Titulo color="black" texto="Todas as Empresas" headingTag="h1" />
      <PlaylistCardList>
        {displayedCompanies.map(company => (
          <Card key={company.url} title={company.titulo} url={company.url} image={company.imagem} chipText="ver mais" />
        ))}
      </PlaylistCardList>
      {nextChunk < rearrangedCompanies.length && !isLoading && <InfiniteScrollComponent fetchMore={getMoreCompanies} />}
      <LoadingLogo isLoading={nextChunk < rearrangedCompanies.length} hasTransparentBackground />
    </>
  );
}
